<template lang="pug">
div
  euro-field.mr-0(
    v-model='data.incomeMonthlyGross',
    label='Bruto basis maandinkomen',
    required,
    :error-messages='incomeMonthlyGrossValidationErrors',
    @change='$v.data.incomeMonthlyGross.$touch()',
    @blur='$v.data.incomeMonthlyGross.$touch()',
    )

  euro-field.mr-0(
    v-model='data.incomeMonthlyNet',
    label='Netto basis maandinkomen',
    required,
    :error-messages='incomeMonthlyNetValidationErrors',
    @change='$v.data.incomeMonthlyNet.$touch()',
    @blur='$v.data.incomeMonthlyNet.$touch()',
    )

  v-layout(column)
    label: b Zijn er overige inkomsten?*
    v-select(
      v-model='data.otherIncome'
      :items='yesNoItems',
      :error-messages='otherIncomeValidationErrors',
      @change='$v.data.otherIncome.$touch()',
      @blur='$v.data.otherIncome.$touch()',
      required,
      solo
      )

  euro-field.mr-0(
    v-if='data.otherIncome',
    v-model='data.otherIncomeNet',
    label='Netto overige inkomsten',
    required,
    :error-messages='otherIncomeNetValidationErrors',
    @change='$v.data.otherIncomeNet.$touch()',
    @blur='$v.data.otherIncomeNet.$touch()',
    )

  v-layout(column)
    label: b Wat is je woonsituatie?*
    v-select(
      label='Wat is je woonsituatie?',
      v-model='data.livingSituation'
      :items='livingSituationItems',
      :error-messages='livingSituationValidationErrors',
      @change='$v.data.livingSituation.$touch()',
      @blur='$v.data.livingSituation.$touch()',
      required,
      solo
      )

  euro-field.mr-0(
    v-if='data.livingSituation === "owner"',
    v-model='data.mortgageMonthlyGross',
    label='Bruto hypotheeklasten',
    required,
    :error-messages='mortgageMonthlyGrossValidationErrors',
    @change='$v.data.mortgageMonthlyGross.$touch()',
    @blur='$v.data.mortgageMonthlyGross.$touch()',
    )

  template(v-if='data.livingSituation === "rental"')
    euro-field.mr-0(
      v-model='data.housingChargesMonthly',
      label='Maandelijkse huurlasten',
      required,
      :error-messages='housingChargesMonthlyValidationErrors',
      @change='$v.data.housingChargesMonthly.$touch()',
      @blur='$v.data.housingChargesMonthly.$touch()',
      )

    euro-field.mr-0(
      v-model='data.housingBenefitsMonthly',
      label='Maandelijkse huurtoeslag',
      required,
      :error-messages='housingBenefitsMonthlyValidationErrors',
      @change='$v.data.housingBenefitsMonthly.$touch()',
      @blur='$v.data.housingBenefitsMonthly.$touch()',
      )

  DatePicker.mr-0(
    label='Woonachtig sinds'
    v-model='data.residentialDateStart'
    ref='residentialDateStart',
    required,
    propName='residentialDateStart',
    @setValid='setValid'
    )

  template(v-if='showAlimonyFields')
    euro-field.mr-0(
      v-model='data.alimonyPartnerMonthly',
      label='Partneralimentatie per maand',
      required,
      :error-messages='alimonyPartnerMonthlyValidationErrors',
      @change='$v.data.alimonyPartnerMonthly.$touch()',
      @blur='$v.data.alimonyPartnerMonthly.$touch()',
      )

    euro-field.mr-0(
      v-model='data.alimonyChildrenMonthly',
      label='Kinderalimentatie per maand',
      required,
      :error-messages='alimonyChildrenMonthlyValidationErrors',
      @change='$v.data.alimonyChildrenMonthly.$touch()',
      @blur='$v.data.alimonyChildrenMonthly.$touch()',
      )

  text-field.mr-0(
    v-model='data.iban',
    label='IBAN-nummer',
    name='iban',
    required,
    :error-messages='ibanValidationErrors',
    @change='$v.data.iban.$touch()',
    @blur='$v.data.iban.$touch()'
    )
</template>

<script>
// import { required, decimal } from 'vuelidate/lib/validators'
import required from 'vuelidate/src/validators/required'
import decimal from 'vuelidate/src/validators/decimal'
import { yesNoDropdownItems } from './helpers/template'
const IBAN = require('ibantools')

export default {
  props: {
    value: Object,
    showAlimonyFields: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      yesNoItems: yesNoDropdownItems,
      livingSituationItems: [
        {
          text: 'Koopwoning',
          value: 'owner'
        },
        {
          text: 'Huurwoning',
          value: 'rental'
        },
        {
          text: 'Inwonend',
          value: 'habitant'
        },
        {
          text: 'Thuiswonend',
          value: 'parental'
        }
      ],

      data: this.value,

      residentialDateStartValid: false
    }
  },

  methods: {
    setValid ({ propName, valid }) {
      this[propName + 'Valid'] = valid
    }
  },

  computed: {
    incomeMonthlyGrossValidationErrors () {
      const errors = []
      if (!this.$v.data.incomeMonthlyGross.$dirty) return errors
      !this.$v.data.incomeMonthlyGross.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.incomeMonthlyGross.required && errors.push('Dit veld is verplicht')
      return errors
    },

    incomeMonthlyNetValidationErrors () {
      const errors = []
      if (!this.$v.data.incomeMonthlyNet.$dirty) return errors
      !this.$v.data.incomeMonthlyNet.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.incomeMonthlyNet.required && errors.push('Dit veld is verplicht')
      return errors
    },

    otherIncomeValidationErrors () {
      const errors = []
      if (!this.$v.data.otherIncome.$dirty) return errors
      !this.$v.data.otherIncome.required && errors.push('Dit veld is verplicht')
      return errors
    },

    otherIncomeNetValidationErrors () {
      const errors = []
      if (!this.$v.data.otherIncomeNet.$dirty) return errors
      !this.$v.data.otherIncomeNet.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.otherIncomeNet.required && errors.push('Dit veld is verplicht')
      return errors
    },

    livingSituationValidationErrors () {
      const errors = []
      if (!this.$v.data.livingSituation.$dirty) return errors
      !this.$v.data.livingSituation.required && errors.push('Dit veld is verplicht')
      return errors
    },

    mortgageMonthlyGrossValidationErrors () {
      const errors = []
      if (!this.$v.data.mortgageMonthlyGross.$dirty) return errors
      !this.$v.data.mortgageMonthlyGross.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.mortgageMonthlyGross.required && errors.push('Dit veld is verplicht')
      return errors
    },

    housingChargesMonthlyValidationErrors () {
      const errors = []
      if (!this.$v.data.housingChargesMonthly.$dirty) return errors
      !this.$v.data.housingChargesMonthly.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.housingChargesMonthly.required && errors.push('Dit veld is verplicht')
      return errors
    },

    housingBenefitsMonthlyValidationErrors () {
      const errors = []
      if (!this.$v.data.housingBenefitsMonthly.$dirty) return errors
      !this.$v.data.housingBenefitsMonthly.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.housingBenefitsMonthly.required && errors.push('Dit veld is verplicht')
      return errors
    },

    alimonyPartnerMonthlyValidationErrors () {
      const errors = []
      if (!this.$v.data.alimonyPartnerMonthly.$dirty) return errors
      !this.$v.data.alimonyPartnerMonthly.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.alimonyPartnerMonthly.required && errors.push('Dit veld is verplicht')
      return errors
    },

    alimonyChildrenMonthlyValidationErrors () {
      const errors = []
      if (!this.$v.data.alimonyChildrenMonthly.$dirty) return errors
      !this.$v.data.alimonyChildrenMonthly.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.alimonyChildrenMonthly.required && errors.push('Dit veld is verplicht')
      return errors
    },

    ibanValidationErrors () {
      const errors = []
      if (!this.$v.data.iban.$dirty) return errors
      !this.$v.data.iban.required && errors.push('Dit veld is verplicht')
      !this.$v.data.iban.iban && errors.push('Dit is geen geldig IBAN nummer')
      return errors
    }
  },

  validations: {
    data: {
      incomeMonthlyGross: {
        required,
        decimal
      },

      incomeMonthlyNet: {
        required,
        decimal
      },

      otherIncome: {
        required
      },

      otherIncomeNet: {
        required: function (v) {
          return !this.otherIncome || !!v
        },
        decimal
      },

      livingSituation: {
        required
      },

      mortgageMonthlyGross: {
        required: function (v) {
          return this.livingSituation !== 'owner' || !!v
        },
        decimal
      },

      housingChargesMonthly: {
        required: function (v) {
          return this.livingSituation !== 'rental' || !!v
        },
        decimal
      },

      housingBenefitsMonthly: {
        required: function (v) {
          return this.livingSituation !== 'rental' || !!v
        },
        decimal
      },

      residentialDateStart: {
        valid: function (v) {
          return this.residentialDateStartValid
        }
      },

      alimonyPartnerMonthly: {
        required: function (v) {
          return !this.showAlimonyFields || !!v
        },
        decimal
      },

      alimonyChildrenMonthly: {
        required: function (v) {
          return !this.showAlimonyFields || !!v
        },
        decimal
      },

      iban: {
        required,
        iban: (v) => IBAN.isValidIBAN(v)
      }
    }
  },

  watch: {
    '$v.$invalid': {
      handler: function (invalid) {
        this.$emit('setValid', {
          modelName: 'financialModel',
          valid: !invalid
        })
      },
      deep: true,
      immediate: true
    },

    value (v) {
      this.data = v
    },

    data: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    },

    'data.iban': function (v) {
      this.data.iban = v.toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
